/**
 * Footer Mobile Navigation JavaScript
 *
 * Handles collapsible submenus on mobile devices for footer navigation.
 * Makes parent links clickable to toggle submenu visibility.
 */
(function() {
    // Function to check if we're on a mobile device
    function isMobile() {
        return window.innerWidth < 768; // You might need to adjust this breakpoint
    }

    // Function to initialize mobile footer navigation
    function initMobileFooterNav() {
        if (!isMobile()) return;

        // Target both footer navigation menus
        const footerParentMenuItems = document.querySelectorAll('.footer-links-group .menu-item-has-children, .footer-links-group .page_item_has_children');
        
        // Remove any existing event listeners first (in case this runs multiple times)
        footerParentMenuItems.forEach(item => {
            const link = item.querySelector('a');
            const submenu = item.querySelector('ul.sub-menu');
            
            if (!link || !submenu) return;
            
            // Remove any existing click listeners
            const newLink = link.cloneNode(true);
            link.parentNode.replaceChild(newLink, link);
            
            // Add the new click listener to toggle submenu
            newLink.addEventListener('click', function(e) {
                if (isMobile()) {
                    e.preventDefault();
                    
                    // Toggle aria-expanded attribute
                    const expanded = newLink.getAttribute('aria-expanded') === 'true' || false;
                    newLink.setAttribute('aria-expanded', !expanded);
                    
                    // Toggle submenu visibility
                    submenu.classList.toggle('toggled-on');
                    item.classList.toggle('submenu-expanded');
                }
            });
            
            // Add appropriate ARIA attributes
            newLink.setAttribute('aria-expanded', 'false');
            submenu.setAttribute('aria-hidden', 'true');
        });
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        initMobileFooterNav();
        
        // Re-initialize on window resize
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(initMobileFooterNav, 250);
        });
    });
})(); 